import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home/home'

import LaTierra from '@/components/views/la-tierra/la-tierra'
import LaBodega from '@/components/views/la-bodega/la-bodega'
import LaAlmanzara from '@/components/views/la-almanzara/la-almanzara'
import SalaDeAzafran from '@/components/views/sala-de-azafran/sala-de-azafran'
import queseria from '@/components/views/queseria/queseria'

import viveAldonza from '@/components/views/experiencias/vive-aldonza'
import recetario from '@/components/views/experiencias/recetario'
import rutaCervantina from '@/components/views/experiencias/ruta-cervantina'
import escuchaAldonza from '@/components/views/experiencias/escucha-aldonza'
import oleoturismo from '@/components/views/experiencias/oleoturismo'
import enoturismo from '@/components/views/experiencias/enoturismo'
import degustacionQuesos from '@/components/views/experiencias/degustacionQuesos'




import productos from '@/components/views/productos/productos';
import fichaProducto from '@/components/views/productos/ficha';
import premios from '@/components/views/productos/premios';
import beneficios from '@/components/views/productos/beneficios';


import Proceso from '@/components/views/proceso'

import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import avisoLegal from '@/components/views/aviso-legal'
import datosSeguros from '@/components/views/datos-seguros'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'


import politicaCookiesEN from '@/components/views/politica-de-cookies-en'
import politicaCookiesRU from '@/components/views/politica-de-cookies-ru'

import avisoLegalEN from '@/components/views/aviso-legal-en'
import datosSegurosEN from '@/components/views/datos-seguros-en'
import politicaPrivacidadEN from '@/components/views/politica-de-privacidad-en'
import politicaPrivacidadRU from '@/components/views/politica-de-privacidad-ru'

import politicaCookiesja from '@/components/views/politica-de-cookies-jp'
import avisoLegalja from '@/components/views/aviso-legal-jp'
import datosSegurosja from '@/components/views/datos-seguros-jp'
import politicaPrivacidadja from '@/components/views/politica-de-privacidad-jp'

import contacto from '@/components/parts/banner-contacto'

Vue.use(Router)


import messages from '@/translations';
import seo from '@/translations/seo';

//SET IDIOMA
import { langdetector } from '@/langdetector';


import { store } from '@/store/store.js';



let en = messages.en.enlaces;
let es = messages.es.enlaces;
let ja = messages.ja.enlaces;
let ko = messages.ko.enlaces;
let ru = messages.ru.enlaces;

let lang = store.getters.getLanguage;
let meta;


const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect: to => {
				let lang = langdetector();
				return messages[lang].enlaces.home
			}
		},
		{ path: `${es.home}/:id?`, name: 'home', component: Home, meta: seo.home },
		{ path: `${en.home}/:id?`, name: 'home', component: Home, meta: seo.home },
/* 		{ path: `${ja.home}/:id?`, name: 'home', component: Home, meta: seo.home },
		{ path: `${ko.home}/:id?`, name: 'home', component: Home, meta: seo.home },
		{ path: `${ru.home}/:id?`, name: 'home', component: Home, meta: seo.home }, */

		{ path: `/newsletter/:lang?`, name: 'newsletter', component: Home, meta: seo.home },

		//LA TIERRA
		{ path: es.la_tierra, name: 'la_tierra', component: LaTierra, meta: seo.la_tierra },
		{ path: en.la_tierra, name: 'la_tierra-en', component: LaTierra, meta: seo.la_tierra },
/* 		{ path: ja.la_tierra, name: 'la_tierra', component: LaTierra, meta: seo.la_tierra },
		{ path: ko.la_tierra, name: 'la_tierra', component: LaTierra, meta: seo.la_tierra },
		{ path: ru.la_tierra, name: 'la_tierra', component: LaTierra, meta: seo.la_tierra }, */

		//LA BODEGA
		{ path: es.la_bodega, name: 'la_bodega', component: LaBodega, meta: seo.la_bodega },
		{ path: en.la_bodega, name: 'la_bodega-en', component: LaBodega, meta: seo.la_bodega },
/* 		{ path: ja.la_bodega, name: 'la_bodega', component: LaBodega, meta: seo.la_bodega },
		{ path: ko.la_bodega, name: 'la_bodega', component: LaBodega, meta: seo.la_bodega },
		{ path: ru.la_bodega, name: 'la_bodega', component: LaBodega, meta: seo.la_bodega }, */

		//QUESERÍA
		{ path: es.queseria, name: 'queseria', component: queseria, meta: seo.queseria },
		{ path: en.queseria, name: 'queseria-en', component: queseria, meta: seo.queseria },
/* 		{ path: ja.queseria, name: 'queseria', component: queseria, meta: seo.queseria },
		{ path: ko.queseria, name: 'queseria', component: queseria, meta: seo.queseria },
		{ path: ru.queseria, name: 'queseria', component: queseria, meta: seo.queseria }, */


		//PROCESO DEL VINO
		{ path: es.proceso_vino, name: 'proceso_vino', component: Proceso, meta: seo.proceso_vino },
		{ path: en.proceso_vino, name: 'proceso_vino', component: Proceso, meta: seo.proceso_vino },
/* 		{ path: ja.proceso_vino, name: 'proceso_vino', component: Proceso, meta: seo.proceso_vino },
		{ path: ko.proceso_vino, name: 'proceso_vino', component: Proceso, meta: seo.proceso_vino },
		{ path: ru.proceso_vino, name: 'proceso_vino', component: Proceso, meta: seo.proceso_vino }, */

		//PROCESO DEL CAVA
		{ path: es.proceso_cava, name: 'proceso_cava', component: Proceso, meta: seo.proceso_cava },
		{ path: en.proceso_cava, name: 'proceso_cava', component: Proceso, meta: seo.proceso_cava },
/* 		{ path: ja.proceso_cava, name: 'proceso_cava', component: Proceso, meta: seo.proceso_cava },
		{ path: ko.proceso_cava, name: 'proceso_cava', component: Proceso, meta: seo.proceso_cava },
		{ path: ru.proceso_cava, name: 'proceso_cava', component: Proceso, meta: seo.proceso_cava }, */

		//PROCESO DEL AZAFRÁN
		{ path: es.proceso_azafran, name: 'proceso_azafran', component: Proceso, meta: seo.proceso_azafran },
		{ path: en.proceso_azafran, name: 'proceso_azafran', component: Proceso, meta: seo.proceso_azafran },
/* 		{ path: ja.proceso_azafran, name: 'proceso_azafran', component: Proceso, meta: seo.proceso_azafran },
		{ path: ko.proceso_azafran, name: 'proceso_azafran', component: Proceso, meta: seo.proceso_azafran },
		{ path: ru.proceso_azafran, name: 'proceso_azafran', component: Proceso, meta: seo.proceso_azafran }, */

		//PROCESO DEL ACEITE
		{ path: es.proceso_aceite, name: 'proceso_aceite', component: Proceso, meta: seo.proceso_aceite },
		{ path: en.proceso_aceite, name: 'proceso_aceite', component: Proceso, meta: seo.proceso_aceite },
/* 		{ path: ja.proceso_aceite, name: 'proceso_aceite', component: Proceso, meta: seo.proceso_aceite },
		{ path: ko.proceso_aceite, name: 'proceso_aceite', component: Proceso, meta: seo.proceso_aceite },
		{ path: ru.proceso_aceite, name: 'proceso_aceite', component: Proceso, meta: seo.proceso_aceite }, */

			//PROCESO DEL QUESO
			{ path: es.proceso_queso, name: 'proceso_queso', component: Proceso, meta: seo.proceso_queso },
 			{ path: en.proceso_queso, name: 'proceso_queso', component: Proceso, meta: seo.proceso_queso },
/*			{ path: ja.proceso_queso, name: 'proceso_queso', component: Proceso, meta: seo.proceso_queso },
			{ path: ko.proceso_queso, name: 'proceso_queso', component: Proceso, meta: seo.proceso_queso },
			{ path: ru.proceso_queso, name: 'proceso_queso', component: Proceso, meta: seo.proceso_queso }, */

		//LA ALMANZARA
		{ path: es.la_almanzara, name: 'la_almanzara', component: LaAlmanzara, meta: seo.la_almanzara },
		{ path: en.la_almanzara, name: 'la_almanzara', component: LaAlmanzara, meta: seo.la_almanzara },
/* 		{ path: ja.la_almanzara, name: 'la_almanzara', component: LaAlmanzara, meta: seo.la_almanzara },
		{ path: ko.la_almanzara, name: 'la_almanzara', component: LaAlmanzara, meta: seo.la_almanzara },
		{ path: ru.la_almanzara, name: 'la_almanzara', component: LaAlmanzara, meta: seo.la_almanzara }, */

		//SALA DE AZAFRÁN
		{ path: es.sala_azafran, name: 'sala_azafran', component: SalaDeAzafran, meta: seo.sala_azafran },
		{ path: en.sala_azafran, name: 'sala_azafran', component: SalaDeAzafran, meta: seo.sala_azafran },
/* 		{ path: ja.sala_azafran, name: 'sala_azafran', component: SalaDeAzafran, meta: seo.sala_azafran },
		{ path: ko.sala_azafran, name: 'sala_azafran', component: SalaDeAzafran, meta: seo.sala_azafran },
		{ path: ru.sala_azafran, name: 'sala_azafran', component: SalaDeAzafran, meta: seo.sala_azafran }, */

		//VIVE ALDONZA
		{ path: `${es.vive_aldonza}:id?`, name: 'vive_aldonza', component: viveAldonza, meta: seo.vive_aldonza },
		{ path: `${en.vive_aldonza}:id?`, name: 'vive_aldonza', component: viveAldonza, meta: seo.vive_aldonza },
/* 		{ path: `${ja.vive_aldonza}:id?`, name: 'vive_aldonza', component: viveAldonza, meta: seo.vive_aldonza },
		{ path: `${ko.vive_aldonza}:id?`, name: 'vive_aldonza', component: viveAldonza, meta: seo.vive_aldonza },
		{ path: `${ru.vive_aldonza}:id?`, name: 'vive_aldonza', component: viveAldonza, meta: seo.vive_aldonza }, */

		//ENOTURISMO
		{ path: es.enoturismo, name: 'enoturismo', component: enoturismo, meta: seo.enoturismo },
		{ path: en.enoturismo, name: 'enoturismo', component: enoturismo, meta: seo.enoturismo },
/* 		{ path: ja.enoturismo, name: 'enoturismo', component: enoturismo, meta: seo.enoturismo },
		{ path: ko.enoturismo, name: 'enoturismo', component: enoturismo, meta: seo.enoturismo },
		{ path: ru.enoturismo, name: 'enoturismo', component: enoturismo, meta: seo.enoturismo }, */

		//OLEOTURISMO
		{ path: es.oleoturismo, name: 'oleoturismo', component: oleoturismo, meta: seo.oleoturismo },
		{ path: en.oleoturismo, name: 'oleoturismo', component: oleoturismo, meta: seo.oleoturismo },
/* 		{ path: ko.oleoturismo, name: 'oleoturismo', component: oleoturismo, meta: seo.oleoturismo },
		{ path: ru.oleoturismo, name: 'oleoturismo', component: oleoturismo, meta: seo.oleoturismo }, */

		//DEGUSTACIÓN DE QUESOS
		{ path: es.degustacionQuesos, name: 'degustacionQuesos', component: degustacionQuesos, meta: seo.degustacionQuesos },
		{ path: en.degustacionQuesos, name: 'degustacionQuesos', component: degustacionQuesos, meta: seo.degustacionQuesos },
/* 		{ path: ja.degustacionQuesos, name: 'degustacionQuesos', component: degustacionQuesos, meta: seo.degustacionQuesos },
		{ path: ko.degustacionQuesos, name: 'degustacionQuesos', component: degustacionQuesos, meta: seo.degustacionQuesos },
		{ path: ru.degustacionQuesos, name: 'degustacionQuesos', component: degustacionQuesos, meta: seo.degustacionQuesos }, */

		//RECETARIO
		{ path: es.recetario, name: 'recetario', component: recetario, meta: seo.recetario },
		{ path: en.recetario, name: 'recetario', component: recetario, meta: seo.recetario },
/* 		{ path: ja.recetario, name: 'recetario', component: recetario, meta: seo.recetario },
		{ path: ko.recetario, name: 'recetario', component: recetario, meta: seo.recetario },
		{ path: ru.recetario, name: 'recetario', component: recetario, meta: seo.recetario }, */

		//RUTA CERVANTINA
		{ path: es.ruta_cervantina, name: 'ruta_cervantina', component: rutaCervantina, meta: seo.ruta_cervantina },
		{ path: en.ruta_cervantina, name: 'ruta_cervantina', component: rutaCervantina, meta: seo.ruta_cervantina },
/* 		{ path: ja.ruta_cervantina, name: 'ruta_cervantina', component: rutaCervantina, meta: seo.ruta_cervantina },
		{ path: ko.ruta_cervantina, name: 'ruta_cervantina', component: rutaCervantina, meta: seo.ruta_cervantina },
		{ path: ru.ruta_cervantina, name: 'ruta_cervantina', component: rutaCervantina, meta: seo.ruta_cervantina }, */

		//PRODUCTOS
		{ path: es.productos, name: 'productos', component: productos, meta: seo.productos },
		{ path: en.productos, name: 'productos', component: productos, meta: seo.productos },
/* 		{ path: ja.productos, name: 'productos', component: productos, meta: seo.productos },
		{ path: ko.productos, name: 'productos', component: productos, meta: seo.productos },
		{ path: ru.productos, name: 'productos', component: productos, meta: seo.productos }, */

		//PREMIOS PRODUCTOS
		{ path: `${es.productos}/:id?${es.premios}`, name: 'premios_ficha', component: premios, meta: seo.premios },
		{ path: `${en.productos}/:id?${en.premios}`, name: 'premios_ficha', component: premios, meta: seo.premios },
/* 		{ path: `${ja.productos}/:id?${ja.premios}`, name: 'premios_ficha', component: premios, meta: seo.premios },
		{ path: `${ko.productos}/:id?${ko.premios}`, name: 'premios_ficha', component: premios, meta: seo.premios },
		{ path: `${ru.productos}/:id?${ru.premios}`, name: 'premios_ficha', component: premios, meta: seo.premios },
 */
		//BENEFICIOS PRODUCTOS
		{ path: `${es.productos}/:id?${es.beneficios}`, name: 'beneficios_ficha', component: beneficios, meta: seo.beneficios },
		{ path: `${en.productos}/:id?${en.beneficios}`, name: 'beneficios_ficha', component: beneficios, meta: seo.beneficios },
/* 		{ path: `${ja.productos}/:id?${ja.beneficios}`, name: 'beneficios_ficha', component: beneficios, meta: seo.beneficios },
		{ path: `${ko.productos}/:id?${ko.beneficios}`, name: 'beneficios_ficha', component: beneficios, meta: seo.beneficios },
		{ path: `${ru.productos}/:id?${ru.beneficios}`, name: 'beneficios_ficha', component: beneficios, meta: seo.beneficios }, */

		//FICHA PRODUCTOS
		{ path: `${es.productos}/:id?/:idproducto?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${en.productos}/:id?/:idproducto?`, name: 'productos_ficha', component: fichaProducto },
/* 		{ path: `${ja.productos}/:id?/:idproducto?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${ko.productos}/:id?/:idproducto?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${ru.productos}/:id?/:idproducto?`, name: 'productos_ficha', component: fichaProducto }, */

		//FICHA PRODUCTOS
		{ path: `${es.productos}/:id?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${en.productos}/:id?`, name: 'productos_ficha', component: fichaProducto },
/* 		{ path: `${ja.productos}/:id?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${ko.productos}/:id?`, name: 'productos_ficha', component: fichaProducto },
		{ path: `${ru.productos}/:id?`, name: 'productos_ficha', component: fichaProducto }, */


		//ESCUCHA ALDONZA
		{ path: es.escucha_aldonza, name: 'escucha_aldonza', component: escuchaAldonza, meta: seo.escuchaAldonza },
		{ path: en.escucha_aldonza, name: 'escucha_aldonza', component: escuchaAldonza, meta: seo.escuchaAldonza },
/* 		{ path: ja.escucha_aldonza, name: 'escucha_aldonza', component: escuchaAldonza, meta: seo.escuchaAldonza },
		{ path: ko.escucha_aldonza, name: 'escucha_aldonza', component: escuchaAldonza, meta: seo.escuchaAldonza },
		{ path: ru.escucha_aldonza, name: 'escucha_aldonza', component: escuchaAldonza, meta: seo.escuchaAldonza }, */

		//POLÍTICA DE PROTECCIÓN DE DATOS
		{ path: es.politica_proteccion, name: 'politica_proteccion', component: politicaPrivacidad, meta: { ...seo.politica_privacidad, noindex: true } },
		{ path: en.politica_proteccion, name: 'politica_privacidad', component: politicaPrivacidadEN, meta: { ...seo.politica_privacidad, noindex: true } },
/* 		{ path: ja.politica_proteccion, name: 'politica_privacidad', component: politicaPrivacidadEN, meta: seo.politica_privacidad },
		{ path: ko.politica_proteccion, name: 'politica_privacidad', component: politicaPrivacidadEN, meta: seo.politica_privacidad },
		{ path: ru.politica_proteccion, name: 'politica_privacidad', component: politicaPrivacidadRU, meta: seo.politica_privacidad }, */

		//AVISO LEGAL
		{ path: es.aviso_legal, name: 'aviso_legal', component: avisoLegal, meta: { ...seo.aviso_legal, noindex: true } },
		{ path: en.aviso_legal, name: 'aviso_legal', component: avisoLegalEN, meta: { ...seo.aviso_legal, noindex: true } },
/* 		{ path: ja.aviso_legal, name: 'aviso_legal', component: avisoLegalEN, meta: seo.aviso_legal },
		{ path: ko.aviso_legal, name: 'aviso_legal', component: avisoLegalEN, meta: seo.aviso_legal },
		{ path: ru.aviso_legal, name: 'aviso_legal', component: avisoLegal, meta: seo.aviso_legal }, */

		//DATOS SEGUROS
		{ path: es.datos_seguros, name: 'datos_seguros', component: datosSeguros, meta: {...seo.datos_seguros, noindex: true } },
		{ path: en.datos_seguros, name: 'datos_seguros', component: datosSegurosEN, meta: {...seo.datos_seguros, noindex: true } },
/* 		{ path: ko.datos_seguros, name: 'datos_seguros', component: datosSegurosEN, meta: seo.datos_seguros },
		{ path: ja.datos_seguros, name: 'datos_seguros', component: datosSegurosEN, meta: seo.datos_seguros },
		{ path: ru.datos_seguros, name: 'datos_seguros', component: datosSeguros, meta: seo.datos_seguros }, */

		//POLÍTICA DE COOKIES
		{ path: es.politica_cookies, name: 'politica_cookies', component: politicaCookies, meta: { ...seo.politica_cookies, noindex: true } },
		{ path: en.politica_cookies, name: 'politica_cookies', component: politicaCookiesEN, meta: { ...seo.politica_cookies, noindex: true } },
/* 		{ path: ko.politica_cookies, name: 'politica_cookies', component: politicaCookiesEN, meta: seo.politica_cookies },
		{ path: ja.politica_cookies, name: 'politica_cookies', component: politicaCookiesEN, meta: seo.politica_cookies },
		{ path: ru.politica_cookies, name: 'politica_cookies', component: politicaCookiesRU, meta: seo.politica_cookies }, */

		{ path: '*', redirect: '/' },
		{ path: "/404", component: Error404, name: '404', meta: { noindex: true } }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (!!to.hash) {
				return {
					selector: to.hash,
					offset: { x: 0, y: (window.innerWidth > 768) ? 60 : -100 }
				}
			} else {
				return { x: 0, y: 0 }
			}
		}
	},
});

import VueAnalytics from 'vue-analytics';


Vue.use(VueAnalytics, {
	id: 'UA-11242406-1',
	router,
	debug: { sendHitTask: true }
});

router.beforeEach((to, from, next) => {

	let withProductos = ['productos_ficha', 'premios_ficha', 'beneficios_ficha'];
	let title;
	let description;

	if (!!seo[to.name]) {

		if (!withProductos.some(e => e == to.name)) {

			if (!!seo[to.name][lang]) {
				title = (!!seo[to.name][lang].title) ? seo[to.name][lang].title : 'Aldonza';
				description = (!!seo[to.name][lang].description) ? seo[to.name][lang].description : 'Aldonza';
			}

		} else {

			let id = to.params.id;
			// if (!!seo && !!seo[to.name][lang][id]) {
			// 	title = (!!seo[to.name][lang][id].title) ? seo[to.name][lang][id].title : 'Aldonza';
			// 	description = (!!seo[to.name][lang][id].description) ? seo[to.name][lang][id].description : 'Aldonza';
			// }
		}

		(!!title) ? document.title = title : null;
		(!!description) ? document.head.querySelector("[name=description]").content = description : null;

	}

  	const robots = document.querySelector('meta[name="robots"]');
  	if (!robots) return;
  	if (to.meta.noindex) {
  	  robots.setAttribute("content", "noindex, follow");
  	} else {
  	  robots.setAttribute("content", "index, follow");
  	}
	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js